import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AppConfig } from './config.type';
import { AppConfigService as ConfigService } from '@cudirect/shared-ui-library';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  // TODO: Re-evaluate this service. This us pulling in the config.json, which is the same data thats available in environment.json
  private env: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private configData: any;
  private netWorkStatus?: boolean = null;
  constructor(private readonly http: HttpClient, private configService: ConfigService) {}

  public setNetworkStatus(status: boolean) {
    this.netWorkStatus = status;
  }

  public getNetworkStatus(): boolean {
    return this.netWorkStatus;
  }

  /**
   * Returns the applications configuration
   * @returns the .json application confiuration from memory or .json
   */
  public get(): Observable<AppConfig> {
    // If we already have a config in memory, return that
    if (this.configData) return of(this.configData);

    // Pulling this data from the correct app config service as a step towards unifying the services.
    this.configData = this.configService.settings;
    return of(this.configData);
  }

  /**
   * Non Observable way to get the config data
   * Good for use in ngOninit and other places where it is known that configData is defined
   * @returns the app config data
   */
  public getData(): AppConfig {
    return this.configData ? this.configData : null;
  }
}
